import urls from 'api/urls'
import axios from 'config/axios'
import localStorage from 'helpers/localStorage'

//, localStorage.getItem('authToken')

const userInformation = async (userInfo) => {
  try {
    const response = await axios.get(urls.getUserInfo, userInfo, localStorage.getItem('authToken'))
    const data = response.data
    localStorage.setItem('userData', data)
    return response.data
  } catch (err) {
    throw new Error(err?.response?.data?.nonFieldErrors?.[0])
  }
}

export { userInformation }
